import SelectPreference from '../SelectPreference/SelectPreference';
import PlayerOptions from './PlayerOptions';
import Loader from '../../common/Loader';

import './RightDrawer.scss';
import {CompetitorType, TrackPoint, useEventContext} from 'providers/EventProvider';
import {drawerWidth} from '../Event';

import {styled} from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Checkbox from './Checkbox';
import {Box, Stack} from '@mui/material';

const CompetitorsHeader = styled(Stack)({
  fontWeight: 'bold',
  borderBottom: '1px solid rgba(0,0,0,0.4)',
  padding: '5px',
  paddingBottom: '10px',
  marginBottom: 0,
  color: '#ff0060',
  backgroundColor: 'white',
  position: 'sticky',
  top: 0,
  zIndex: 1,
  alignItems: 'center'
});

const CompetitorsContainer = styled('div')({
  flex: 1,
  overflowY: 'auto'
});

const DrawerFooter = styled('div')({
  backgroundColor: 'white',
  borderTop: '1px solid rgba(0,0,0,0.12)',
  display: 'flex',
  justifyContent: 'flex-end',
  padding: 4
});

const RightDrawer = (props: RightDrawerProps) => {
  const {loading, open, setOpen} = props;

  const {players, updatePlayers, time, options, updateOptions} = useEventContext();

  const onChangeAllPlayersShow = () => {
    const show = !options.showAllPlayers;
    players.forEach((p) => {
      p.options.show = show;
    });
    updatePlayers([...players]);
    options.showAllPlayers = show;
    updateOptions(options);
  };

  const onChangeCenter = (player: CompetitorType) => {
    let timeValue = time;
    if (options.isMassStart) {
      timeValue += player.offsetTime;
    } else {
      timeValue += options.startEventTime;
    }
    const poly: TrackPoint[] = [];
    player.track.forEach((d, i) => {
      if (d.time <= timeValue) {
        poly.push(d);
      }
    });
    if (poly.length > 0) {
      const point = poly[poly.length - 1];
      options.center = point;
      updateOptions(options);
    }
  };

  return (
    <Drawer
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 1000,
        width: open ? drawerWidth : 0,
        minWidth: 0,
        height: '100%',
        overflow: 'hidden',
        pointerEvents: open ? 'auto' : 'none',
        transition: 'width 0.2s ease',
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          position: 'absolute',
          top: 0,
          right: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          border: 'none',
          borderLeft: '1px solid #f0f0f2',
          boxShadow: '-4px 0 16px rgba(0, 0, 0, 0.12)'
        }
      }}
      variant="persistent"
      anchor="right"
      open={open}
    >
      <CompetitorsHeader direction="row">
        <Checkbox checked={options.showAllPlayers} onClick={onChangeAllPlayersShow} />
        <Box sx={{flex: 1}}>All Competitors</Box>
        <IconButton onClick={() => setOpen(false)} size="small" sx={{color: '#ff0060'}} aria-label="Close competitors">
          <ChevronRightIcon />
        </IconButton>
      </CompetitorsHeader>
      <CompetitorsContainer>
        {loading ? (
          <Loader sx={{margin: 2}} />
        ) : (
          <>
            {players.map((p, i) => (
              <PlayerOptions key={i} player={p} onChangeCenter={onChangeCenter} />
            ))}
          </>
        )}
      </CompetitorsContainer>
      <DrawerFooter>
        <SelectPreference />
      </DrawerFooter>
    </Drawer>
  );
};

export default RightDrawer;

type RightDrawerProps = {
  loading: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
};
